import styled from '@emotion/styled';
import { Input } from 'antd';
import React from 'react';
import { connect } from 'react-redux';

import { AppState } from 'src/config/appState';
import { color, font } from 'src/shared/styles/variables';

import { changeStepsQuestionAnswer } from '../actions/surveysActions';
import {
    QuestionComponentBaseProps,
    StepAnswer,
    SurveyStepsQuestionAnswer,
    SurveyStepsQuestionStep,
} from '../models/surveys';
import { getProgramSurveySingleQuestionAnswer } from '../selectors/surveysSelectors';
import { QuestionHeader } from './QuestionHeader';

const InputWrapper = styled('div')({
    display: 'flex',
    justifyContent: 'space-around',
    marginTop: '1.31rem',
});

const StyledLabel = styled('label')(
    {
        paddingTop: '0.44rem',
        marginRight: '0.88rem',
        color: color.blueLagoon,
        maxWidth: '10.50rem',
    },
    font.heavy(font.size.medium),
);

const StyledInput = styled(Input)({
    flexGrow: 1,
    width: 'auto',
});

interface StateProps {
    answer: SurveyStepsQuestionAnswer | undefined;
}

interface ActionsProps {
    changeStepsQuestionAnswer: typeof changeStepsQuestionAnswer;
}

interface Props extends QuestionComponentBaseProps, ActionsProps, StateProps {
    steps: SurveyStepsQuestionStep[];
    inTable?: boolean;
}

class StepsQuestionContainer extends React.Component<Props> {
    public handleInputChange = (stepId: string) => (e: React.ChangeEvent<HTMLInputElement>) => {
        const { programId, surveyId, id } = this.props;

        this.props.changeStepsQuestionAnswer({
            programId,
            surveyId,
            question: id,
            value: e.target.value,
            stepId,
        });
    };

    public getStepAnswer = (answers: StepAnswer[] | undefined, stepId: string) => {
        const givenAnswer = answers && answers.find(answer => answer.id === stepId);
        return givenAnswer && givenAnswer.content;
    };

    public render(): JSX.Element {
        const { question, steps, inTable, answer, readableIndex } = this.props;

        return (
            <>
                {inTable ? (
                    steps.map(step => (
                        <td key={step.id}>
                            <StyledInput
                                value={answer && this.getStepAnswer(answer.data.content, step.id)}
                                placeholder={step.placeholder}
                                onChange={this.handleInputChange(step.id)}
                            />
                        </td>
                    ))
                ) : (
                    <>
                        {question && <QuestionHeader index={readableIndex} header={question} />}
                        {steps.map(step => (
                            <InputWrapper key={step.id}>
                                <StyledLabel>{step.label}</StyledLabel>
                                <StyledInput
                                    value={
                                        answer && this.getStepAnswer(answer.data.content, step.id)
                                    }
                                    placeholder={step.placeholder}
                                    onChange={this.handleInputChange(step.id)}
                                />
                            </InputWrapper>
                        ))}
                    </>
                )}
            </>
        );
    }
}

const mapStateToProps = (state: AppState, { programId, surveyId, id }: Props): StateProps => ({
    answer: getProgramSurveySingleQuestionAnswer(state, programId, surveyId, id) as
        | SurveyStepsQuestionAnswer
        | undefined,
});

export const StepsQuestion = connect<StateProps, ActionsProps>(mapStateToProps, {
    changeStepsQuestionAnswer,
})(StepsQuestionContainer);
